import { showInChat } from '@/events.config.js'
export const subscribeMessages = {
  data: () => ({
    stack: {},
    canSubscribe: false
  }),
  computed: {
    isSocketAuth() {
      return this.$store.getters.IS_SOCKET_AUTH
    }
  },
  watch: {
    canSubscribe() {
      if (this.canSubscribe && this.isSocketAuth) {
        this.subscribe()
      }
      // else if (!this.canSubscribe) {
      //   this.unsubscribe()
      // }
    }
  },
  created() {
    if (this.canSubscribe && this.isSocketAuth) {
      this.subscribe()
    }
  },
  // beforeDestroy() {
  //   this.unsubscribe()
  // },
  methods: {
    subscribe() {
      this.sockets.subscribe('api/messages created', data => {
        if (this.activeChat == data.course_id) this.changeChatEvent(data)
      })
      this.sockets.subscribe('api/messages_mobile created', data => {
        if (this.activeChat == data.course_id) this.changeChatEvent(data)
      })
      this.sockets.subscribe('api/mobile-events created', event => {
        if (showInChat.includes(event.episodeType)) {
          this.addEvent(event)
        }
      })
    },
    unsubscribe() {
      this.sockets.unsubscribe('api/messages created')
    }
  }
}
